<span>
     <span *ngIf="hideButton === false" class="pr-2">
          <button
               type="button"
               [class]="buttonClass"
               (click)="buttonClick(params)"
               [name]="buttonName"
               [id]="buttonName"
               [title]="buttonText"
          >
               {{ buttonText }}
               <i *ngIf="buttonIcon !== ''" [class]="buttonIcon"></i>
          </button>
     </span>
     <label class="hide-button-text"
     > {{hideButtonText}} </label>

     <span *ngIf="hideProbationButton === false">
          <button
               type="button"
               [class]="probationButtonClass"
               (click)="probationButtonClick(params)"
               [name]="probationButtonName"
               [id]="probationButtonName"
               [title]="probationButtonText"
          >
               {{ probationButtonText }}
               <i *ngIf="probationButtonIcon !== ''" [class]="probationButtonIcon"></i>
          </button>
     </span>
</span>



<style scoped>
.hide-button-text {
    font-style: italic;
    color: #555555;
}
</style>
